<template>
  <div class="wg-row com-anm22-app-scrolling-panel" style="justify-content:center;height:calc(100vh - 107px);padding:10px;">
    <div class="wg-row" :style="view === 'list' ? 'max-width:600px;' : ''">
      <!-- Titolo e tasti di visualizzazione -->
      <div class="wg-row" style="align-items:center;justify-content:space-between;">
        <div class="wg-col wg-xs-11">
          <slot></slot>
        </div>
        <!-- Switch visualizzazione -->
        <div class="wg-col wg-xs-1 display-flex" style="align-items:center;justify-content:flex-end;">
          <img
            :src="view === 'list' ? $anm22.icons.getWorldIcon('viewCols') : $anm22.icons.getWorldIcon('viewFull')"
            class="com-anm22-app-img-s"
            style="cursor:pointer;"
            @click="changeView"
          >
          <img
            v-if="windowWidth <= 992"
            :src="$anm22.icons.getWorldIcon('chat')"
            class="com-anm22-app-img-s"
            style="cursor:pointer;margin-left:5px;"
            @click="$emit('openBoard')"
          >
        </div>
      </div>
      <!-- Modale per cancellazione evento -->
      <wg-modal v-if="deleteEventDialog" :portal="true" @closeModal="closeDeleteDialog">
        <div class="wg-row" style="justify-content:center;" slot="body">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Delete shift?', 'Cancellare turno?') }}
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row" style="align-items:center;justify-content:center;">
            <input 
                type="button" 
                class="small com-anm22-button-blue" 
                :value="$anm22.strLang(lang, 'OK', 'OK')" 
                @click="deleteEvent">
            <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
            <input 
                type="button" 
                class="small com-anm22-button-red" 
                :value="$anm22.strLang(lang, 'Cancel', 'Annulla')" 
                @click="closeDeleteDialog">
          </div>
        </div>
      </wg-modal>
      <!-- Modale per gestione rapida modifica evento -->
      <wg-spinner-modal v-if="eventLoading"></wg-spinner-modal>
      <wg-modal :width="windowWidth > 700 ? '700px' : '90%'" v-if="showEventDialog" :portal="true" @closeModal="showEventDialog = !showEventDialog">
        <div class="wg-row" slot="header" style="flex-wrap:nowrap:align-items:center;">
          <img 
              v-if="!isSynchronized(selectedEvent)"
              :src="$anm22.icons.getWorldIcon('offline')"
              class="com-anm22-app-img-fixed-height-m icon"
              style="margin-right:5px;"
              :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
          >
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Edit shift', 'Modifica turno') }}
          </div>
        </div>
        <event-detail slot="body" :project-id="projectId" :event-ref="selectedEvent"></event-detail>
      </wg-modal>
      <!-- Visualizzazione lista -->
      <template v-if="view === 'list'">
        <template v-if="runningTask">
          <div v-if="runningTask.p && (runningTask.p == projectId)" class="headbar-notification-running-task">
            <img :src="$anm22.icons.getWorldIcon('sprint')" class="sprint-icon" />
            <div class="running-task-title">{{ $anm22.strLang(lang, 'Time tracking', 'Monitoraggio tempo') }}</div>
            <div class="start-time"><div class="time-label">{{ $anm22.strLang(lang, 'Start', 'Inizio') }}:</div>{{ runningTaskStartTime }}</div>
            <div class="stop-btn" @click="timerStop()" :title="$anm22.strLang(lang, 'Stop', 'Stop')"><img :src="$anm22.icons.getWorldIcon('mediaStop')" /></div>
          </div>
        </template>
        <template v-else>
          <div class="headbar-notification-running-task">
            <div class="running-task-title">{{ $anm22.strLang(lang, 'Time tracking', 'Monitoraggio tempo') }}</div>
            <div class="running-task-desc">{{ $anm22.strLang(lang, 'Start timer', 'Avvia il turno') }}</div>
            <div class="play-btn" @click="timerStart()" :title="$anm22.strLang(lang, 'Play', 'Play')"><img :src="$anm22.icons.getWorldIcon('mediaPlay')" /></div>
          </div>
        </template>
      </template>
      <template v-if="timezoneSelectOptions.length > 1">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
          <div class="com-anm22-app-text-l" style="white-space:nowrap;">
            {{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}
          </div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;">
            <div 
                v-for="(opt,i) in timezoneSelectOptions"
                :key="'tz-opt-'+i"
                :class="['timezone-btn', selectedTimezone === opt.zone ? 'selected' : '']"
                @click="selectedTimezone = opt.zone">
              {{ opt.name + ' ('+$moment.tz(opt.zone).zoneName()+')' }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="view === 'list'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="align-items:center;">
          <div class="com-anm22-app-text-xxl">
            {{ $anm22.strLang(lang, 'Shifts', 'Elenco turni') }}
          </div>
          <input 
              v-if="canAdd"
              type="button" 
              class="small"
              style="margin-left:auto;"
              :value="$anm22.strLang(lang, '+ Add shift', '+ Aggiungi turno')"
              @click="addEvent()">
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div v-if="loading && events.length === 0" class="wg-row" style="margin:10px;justify-content:center;">
          <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)" />
        </div>
        <div v-else class="wg-row">
          <div 
              v-if="events.length === 0"
              class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'No shift for this project yet', 'Nessun turno per questo progetto') }}
          </div>
          <div 
              v-else
              v-for="(event,index) in events.sort((a,b) => b.startTimestamp - a.startTimestamp).filter(e => e)"
              :key="'e'+index"
              class="wg-row com-anm22-app-white-container event-row o-workshift-box"
              style="align-items:center;">
            <img 
                v-if="!isSynchronized(event)"
                :src="$anm22.icons.getWorldIcon('offline')"
                class="com-anm22-app-img-fixed-height-m icon"
                :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
            >
            <img 
                :src="getEventIcon(event.type)"
                class="com-anm22-app-img-fixed-height-m icon"
            >
            <div class="display-flex" style="flex-grow:1;overflow:hidden;align-items:center;">
              <div class="name">
                {{ event.name }}
              </div>
              <div class="date" :title="getTimeLabelExtended(event)">
                {{ getTimeLabel(event) }}
              </div>
            </div>
            <div v-if="event.jsonData && event.jsonData.kilometers" class="com-anm22-app-text-xl km">
              ({{ event.jsonData.kilometers }} km)
            </div>
            <template v-if="canEdit(event)">
              <img 
                  :src="$anm22.icons.getWorldIcon('copy')"
                  class="com-anm22-app-img-fixed-height-s img"
                  style="cursor:pointer;"
                  :title="$anm22.strLang(lang, 'Copy event', 'Copia evento')"
                  @click="copyEvent(event)"
                  >
              <img 
                  :src="$anm22.icons.getWorldIcon('edit')"
                  class="com-anm22-app-img-fixed-height-s img"
                  style="cursor:pointer;"
                  :title="$anm22.strLang(lang, 'Edit event', 'Modifica evento')"
                  @click="openEvent(event)"
                  >
              <img 
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  class="com-anm22-app-img-fixed-height-s img"
                  style="cursor:pointer;"
                  :title="$anm22.strLang(lang, 'Delete event', 'Cancella evento')"
                  @click="openDeleteDialog(event)"
                  >
            </template>
            <div 
                v-for="(user,uIndex) in getEventUsers(event)"
                :key="'user-'+index+'-'+uIndex"
                class="user"
                style="min-width:22px;width:22px;height:22px;">
              <world-object-icon
                  :type="'user'" 
                  :obj="user"
                  :isImg="true">
              </world-object-icon>
            </div>
          </div>
        </div>
      </template>
      <!-- Visualizzazione griglia settimana -->
      <template v-else>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- Tasti di selezione settimana -->
        <div class="wg-row" style="align-items:center;">
          <img 
              class="com-anm22-app-img-fixed-height-s"
              style="cursor:pointer;"
              :src="$anm22.icons.getWorldIcon('arrowLeft')"
              @click="weekBefore">
          <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
          <img 
              class="com-anm22-app-img-fixed-height-s"
              style="cursor:pointer;"
              :src="$anm22.icons.getWorldIcon('arrowRight')"
              @click="weekAfter">
          <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
          <div class="com-anm22-app-text-xl">
            {{ dateSelector | moment('MMMM') }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row com-anm22-tasks-pw-canvas" style="min-height:calc(100vh - 277px);">
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div class="wg-row com-anm22-tasks-pw-header" style="border-right:1px solid #ccc;">
            <div
                v-for="(day,index) in daysOfWeek"
                :key="'d'+index"
                class="display-flex com-anm22-tasks-pw-header-elem"
                :style="$moment().isSame(day, 'day') ? 'color:#f00;' : ''">
              <div class="com-anm22-app-text-l">{{ day | moment('DD') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="com-anm22-app-text-l">{{ day | moment('ddd') }}</div>
            </div>
          </div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div class="wg-row com-anm22-tasks-pw-content" style="border-right:1px solid #ccc;
          ">
            <div
                v-for="(day,index) in daysOfWeek"
                :key="'d'+index"
                class="display-flex com-anm22-tasks-pw-content-elem">
              <!-- Ciclo prima gli eventi nell'array, poi eventualmente riempio gli altri spazi -->
              <div class="wg-row com-anm22-tasks-pw-shift-container"
                  style="margin-bottom:5px;"
                  v-for="(event,i) in eventsMatrix[index]"
                  :key="'ed-'+i">
                <template v-if="event !== null">
                  <div class="wg-row" style="align-items:center;height:33%;flex-wrap:nowrap;">
                    <img 
                        v-if="!isSynchronized(event)"
                        :src="$anm22.icons.getWorldIcon('offline')"
                        class="com-anm22-app-img-fixed-height-m"
                        style="margin-right:2px;"
                        :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
                    >
                    <img 
                        :src="getEventIcon(event.type)"
                        class="com-anm22-app-img-fixed-height-m event-icon"
                        style="margin-right:2px;"
                    >
                    <!-- <div class="com-anm22-app-horizontal-space" style="width:2px;"></div> -->
                    <div 
                        v-if="event.creator"
                        class="event-creator"
                        style="min-width:20px;width:20px;height:20px;">
                      <world-object-icon
                          :type="'user'" 
                          :obj="getCreator(event.creator)"
                          :isImg="true">
                      </world-object-icon>
                    </div>
                    <div class="com-anm22-app-horizontal-space" style="width:2px;"></div>
                    <div class="com-anm22-app-text-l" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                      {{ event.name }}
                    </div>
                    <img 
                        v-if="canAdd"
                        :src="$anm22.icons.getWorldIcon('copy')"
                        class="com-anm22-app-img-fixed-height-m"
                        style="margin-left:auto;padding:2px;cursor:pointer;"
                        :title="$anm22.strLang(lang, 'Copy event', 'Copia evento')"
                        @click="copyEvent(event)"
                    >
                    <img 
                        v-if="canEdit(event)"
                        :src="$anm22.icons.getWorldIcon('edit')"
                        class="com-anm22-app-img-fixed-height-m"
                        style="padding:2px 4px;cursor:pointer;"
                        :title="$anm22.strLang(lang, 'Edit shift', 'Modifica turno')"
                        @click="openEvent(event)">
                    <img 
                        v-if="canEdit(event)"
                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                        class="com-anm22-app-img-fixed-height-m"
                        style="cursor:pointer;"
                        :title="$anm22.strLang(lang, 'Delete shift', 'Elimina turno')"
                        @click="openDeleteDialog(event)">
                  </div>
                  <div class="wg-row" style="align-items:center;height:33%;flex-wrap:nowrap;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'From', 'Da') }}
                    </div>
                    <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                    <div 
                        v-if="checkIfMultDays(event) && checkBeforeOrAfter(event.startTimestamp, day) === 'before'"
                        class="com-anm22-app-text-m"
                        style="color:gray;margin-right:2px;">
                      {{ timestampToTimezone(event.startTimestamp).format('DD-MM') }}
                    </div>
                    <div
                        class="com-anm22-app-text-l"
                        style="margin-left:auto;">
                      {{ timestampToTimezone(event.startTimestamp).format('HH:mm') }}
                    </div>
                  </div>
                  <div class="wg-row" style="align-items:center;height:33%;flex-wrap:nowrap;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'To', 'A') }}
                    </div>
                    <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                    <div 
                        v-if="checkIfMultDays(event) && checkBeforeOrAfter(event.endTimestamp, day) === 'after'"
                        class="com-anm22-app-text-m"
                        style="color:gray;margin-right:2px;">
                      {{ timestampToTimezone(event.endTimestamp).format('DD-MM') }}
                    </div>
                    <div
                        class="com-anm22-app-text-l"
                        style="margin-left:auto;">
                      {{ timestampToTimezone(event.endTimestamp).format('HH:mm') }}
                    </div>
                  </div>
                </template>
                <template v-else-if="canAdd">
                  <div  class="wg-row event-plus-div" @click="addEvent(day)">
                    <img 
                        :src="$anm22.icons.getWorldIcon('addGreen')"
                        class="com-anm22-app-img-fixed-height-l">
                  </div>
                  <!-- TO-DO add button in visualizzazione settimanale -->
                </template>
              </div>
            </div>
          </div>
          <div class="com-anm22-app-horizontal-line-light"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventDetail from "../components/event/EventDetail.vue";
import Spinner from 'vue-simple-spinner';

export default {
  props: {
    projectId: [Number, String],
    customerManager: [Boolean],
    action: String
  },
  data() {
    return {
      view:
        this.$anm22.getCookie("tk_e_view") !== ""
          ? this.$anm22.getCookie("tk_e_view")
          : "list",
      loading: false,
      //I tasti di navigazione nelle settimane modificano questo parametro
      weeksOffset: 0,
      eventLoading: false,
      showEventDialog: false,
      selectedEvent: null,
      deleteEventDialog: false,
      eventToDelete: null,
      updateInterval: null,
      selectedTimezone: this.$moment.tz.guess(),
      deleteRunningTask: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth,
      runningTask: state => state.headbar.runningTask,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    events() {
      return this.project.events.map(e => this.$store.getters["events/get"](e));
    },
    licenses() {
      return this.$store.getters['employments/getByUser'](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters['licenses/getByWork'](e.work))
        .filter(l => l);
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    reports() {
      return this.$store.getters['employeeExpenseReports/getAll']
        .filter(r => this.project.users.includes(r.user) && this.project.developers.includes(r.work));
    },
    canAdd() {
      return this.licenses
        .filter(l => (l.config.tasks && l.config.tasks.events && l.config.tasks.events['add-rules']) )
        .reduce((result, l) => result && 
          this.$anm22[l.config.tasks.events['add-rules']](this)
        , true);
    },
    /* GESTIONE TIMESTAMP E TIMEZONE */
    timezoneSelectOptions() {
      const opts = [];
      if(this.project.timezone) {
        this.selectedTimezone = this.project.timezone;
        opts.push({name: this.$anm22.strLang(this.lang, 'Project', 'Progetto'), zone: this.project.timezone});
      }
      opts.push({name: this.$anm22.strLang(this.lang, 'Local', 'Locale'), zone: this.$moment.tz.guess()});
      return opts;
    },
    dateSelector() {
      return this.$moment().tz(this.selectedTimezone).add(this.weeksOffset, 'weeks');
    },
    daysOfWeek() {
      let days = [];
      let monday = this.dateSelector.clone().startOf("week");
      for (let i = 0; i < 7; i++) {
        let day = monday.clone().add(i, "days");
        days.push(day);
      }
      return days;
    },
    eventsMatrix() {
      let matrix = [];
      for (let i = 0; i < this.daysOfWeek.length; i++) {
        matrix[i] = [];
      }
      this.events.sort((a,b) => a.startTimestamp - b.startTimestamp).filter(e => e).forEach(e => {
        const start = this.timestampToDate(e.startTimestamp);
        const end = this.timestampToDate(e.endTimestamp);
        for (let i = 0; i < this.daysOfWeek.length; i++) {
          const day = this.daysOfWeek[i];
          const dayFromDate = this.$moment(day.format('YYYY')+'-'+day.format('MM')+'-'+day.format('DD'));
          if(start.isSameOrBefore(day, 'day') && end.isSameOrAfter(dayFromDate, 'day')) {
            matrix[i].push(e);
          }
          // if (
          //     start.format('DD') == day.format('DD') 
          //     && start.format('MM') == day.format('MM') 
          //     && start.format('YYYY') == day.format('YYYY') 
          //     // && start.format('DD') < day.clone().add(1, "days").format('DD')
          //     // && start.format('MM') == day.clone().add(1, "days").format('MM')
          //     // && start.format('YYYY') == day.clone().add(1, "days").format('YYYY')
          // ) {
          // // if (start.isBetween(day, day.clone().add(1, "days"), null, "[)")) {
          //   matrix[i].push(e);
          //   //Controllo se l'evento prosegue nei giorni successivi
          //   let index = i + 1;
          //   const nextDay = day.clone().add(index - i, "days");
          //   while (
          //     index < this.daysOfWeek.length &&
          //     (end.format('DD') >= nextDay.format('DD')
          //     && end.format('MM') >= nextDay.format('MM')
          //     && end.format('YYYY') >= nextDay.format('YYYY'))
          //     // end.format('DD') > day.clone().add(index - i, "days").format('DD')
          //     // end.isAfter(day.clone().add(index - i, "days"), "day")
          //   ) {
          //     matrix[index].push(e);
          //     index++;
          //     nextDay.add(1, 'days');
          //   }
          // }
        }
      });
      //Riempio gli spazi vuoti fino ad arrivare a 4 elementi
      matrix.forEach(r => {
        while (r.length < 4) {
          r.push(null);
        }
      });
      // console.log(matrix);
      //Ottengo una matrice di giornixeventi per poter costruire la grafica
      return matrix;
    },
    runningTaskStartTime() {
      if (this.runningTask) {
        if ((Date.now() - (this.runningTask.st * 1000)) < 86400000) {
          return this.$moment.unix(this.runningTask.st).format("HH:mm")
        } else {
          return this.$moment.unix(this.runningTask.st).format("YYYY-MM-DD")
        }
      }
    },
  },
  methods: {
    isSynchronized(event) {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldEvent' + event.idWorldEvent));
    },
    searchFn(string) {
      const regexp = new RegExp(string, 'i');
      let results = [];
      /* Ricerca contatti per nome */
      this.events
        .filter(e => {
          return -1 !== e.name.search(regexp);
        })
        .map(e => {
          return {
            label: e.name,
            img: this.$anm22.icons.getTasksIcon('eventsBlack'),
            submitFn: () => {
              this.openEvent(e);
            }
          }
        })
        .forEach(res => {
          results.push(res);
        });
      return results;
    },
    canEdit(event) {
      return this.licenses
        .filter(l => (l.config.tasks && l.config.tasks.events && l.config.tasks.events['edit-rules']) )
        .reduce((result, l) => result && 
          this.$anm22[l.config.tasks.events['edit-rules']](this, event)
        , true);
    },
    changeView() {
       if (this.view === "list") {
        this.view = "week";
        this.$anm22.setCookie("tk_e_view", "wwek", 31536000);
      } else {
        this.view = "list";
        this.$anm22.setCookie("tk_e_view", "list", 31536000);
      }
    },
    getEventUsers(event) {
      const invites = this.$store.getters['invites/getByEvent'](event.idWorldEvent)
        .filter(i => i.status === 1);
      if(invites.length > 0) {
        return invites.map(i => this.$store.getters['users/get'](i.user));
      } else {
        return [this.$store.getters['users/get'](event.creator)];
      }
    },
    getCreator(userId) {
      return this.$store.getters["users/get"](userId);
    },
    getEventIcon(type) {
      switch (type) {
        case 2:
          return require("../../../../calendar/images/activities/ic_local_airport_black_48px.svg");
          break;
        case 3:
          return require("../../../utilities/img/icons/night-event.png");
          break;
        default:
          return require("../../../../world/images/apps/app-calendar.png");
      }
    },
    timestampToTimezone(ts) {
      return this.$moment.unix(ts).tz(this.selectedTimezone);
    },
    timestampToDate(ts) {
      const moment = this.timestampToTimezone(ts);
      return this.$moment(moment.format('YYYY')+'-'+moment.format('MM')+'-'+moment.format('DD'));
    },
    getTimeLabel(event) {
      let string = "";
      const start = this.$moment.unix(event.startTimestamp).tz(this.selectedTimezone);
      const end = this.$moment.unix(event.endTimestamp).tz(this.selectedTimezone);
      string += start.format("D MMM");
      if (start.format("D MMM") !== end.format("D MMM")) {
        string += " " + start.format("H:mm") + " - " + end.format("D MMM");
      } else {
        string += " - " + start.format("H:mm");
      }
      string += " " + end.format("H:mm");
      return string;
    },
    getTimeLabelExtended(event) {
      let string = "";
      const start = this.$moment.unix(event.startTimestamp).tz(this.selectedTimezone);
      const end = this.$moment.unix(event.endTimestamp).tz(this.selectedTimezone);
      string += start.format("DD MMMM YYYY");
      if (start.format("DD MMMM YYYY") !== end.format("DD MMMM YYYY")) {
        string += " " + start.format("HH:mm") + " - " + end.format("DD MMMM YYYY");
      } else {
        string += " - " + start.format("HH:mm");
      }
      string += " " + end.format("HH:mm");
      return string;
    },
    addEvent(day) {
      const start = this.$moment();
      if(day) {
        const date = this.$moment(day.tz(this.$moment.tz.guess()).format());
        start.year(date.year()).month(date.month()).date(date.date());
      }
      /* Creo un nuovo evento fittizio, inserimento vero e proprio solo alla pressione del tasto salva */
      this.openEvent({
        name: "",
        startTimestamp: start.unix(),
        endTimestamp: start.clone()
          .add(1, "hours")
          .unix(),
        timezone: this.project.timezone || 'Europe/Rome',
        type: 1,
        creator: this.user.idWorldUser
      });
    },
    addEventByStartTime(start) {
      const end = this.$moment();
      /* Creo un nuovo evento fittizio, inserimento vero e proprio solo alla pressione del tasto salva */
      this.openEvent({
        name: "",
        startTimestamp: start,
        endTimestamp: end.unix(),
        timezone: this.project.timezone || 'Europe/Rome',
        type: 1,
        creator: this.user.idWorldUser,
        tempTimeTracking: true
      });
    },
    copyEvent(event) {
      const newEvent = {...event};
      delete newEvent.idWorldEvent;
      this.openEvent(newEvent);
    },
    openEvent(event) {
      this.eventLoading = true;
      if (event.idWorldEvent) {
        //Modifica di evento
        this.$http
          .get("event?idWorldEvent=" + event.idWorldEvent)
          .then(response => {
            //aggiorno il db locale con la risposta
            return Promise.all([
              this.$store.dispatch('events/update', {
                vlf: this.$vlf('events'),
                objs: [response.data.event]
              }),
              this.$store.dispatch('users/update', {
                vlf: this.$vlf('users'),
                objs: [response.data.user]
              })
            ])
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.selectedEvent = this.$store.getters["events/get"](
              event.idWorldEvent
            );
            this.eventLoading = false;
            this.showEventDialog = true;
          });
      } else {
        //Creazione nuovo evento
        this.selectedEvent = event;
        this.eventLoading = false;
        this.showEventDialog = true;
      }
    },
    openDeleteDialog(event) {
      this.eventToDelete = event;
      this.deleteEventDialog = true;
    },
    closeDeleteDialog() {
      this.eventToDelete = null;
      this.deleteEventDialog = false;
    },
    deleteEvent() {
      this.$http
        .post("event/delete", {
          projectId: this.projectId,
          eventId: this.eventToDelete.idWorldEvent
        }, {
          withCredentials: true
        })
        .then(response => {
          let project = {...this.project};
          project.events.splice(project.events.findIndex(e => e === this.eventToDelete.idWorldEvent), 1);
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'), 
              objs: [project]
            }),
            this.$store.dispatch('events/delete', {
              vlf: this.$vlf('events'), 
              obj: this.eventToDelete
            })
          ])
          .then(result => {
            this.closeDeleteDialog();
            this.$anm22.eventBus.$emit('wg-dialog-close');
          });
        })
        .catch(error => {
          let project = {...this.project};
          project.events.splice(project.events.findIndex(e => e === this.eventToDelete.idWorldEvent), 1);
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'), 
              objs: [project]
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: 'edit',
              type: 'obj',
              obj: this.project
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldProject",
            //   'edit',
            //   this.project
            // ),
            this.$store.dispatch('events/delete', {
              vlf: this.$vlf('events'), 
              obj: this.eventToDelete
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldEvent",
              _table: "events",
              mode: 'delete',
              type: 'obj',
              obj: this.eventToDelete
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldEvent",
            //   'delete',
            //   this.eventToDelete
            // )
          ])
          .then(result => {
            this.closeDeleteDialog();
            this.$anm22.eventBus.$emit('wg-dialog-close');
          });
        });
    },
    weekBefore() {
      this.weeksOffset--;
    },
    weekAfter() {
      this.weeksOffset++;
    },
    checkIfMultDays(e) {
      const start = this.timestampToDate(e.startTimestamp);
      const end = this.timestampToDate(e.endTimestamp);
      return !start.isSame(end, 'day');
    },
    checkBeforeOrAfter(ts, day) {
      const moment = this.timestampToDate(ts);
      const dayFromDate = this.$moment(day.format('YYYY')+'-'+day.format('MM')+'-'+day.format('DD'));
      if(moment.isBefore(dayFromDate, 'day')) {
        return 'before';
      } else if(moment.isAfter(dayFromDate, 'day')){
        return 'after';
      }
    },
    loadData() {
      Promise.all([
        this.$store.dispatch("events/load", this.$vlf('events')),
        this.$store.dispatch("users/load", this.$vlf('events'))
      ]).then(() => {
        this.$Progress.finish();
        this.loading = false;
        if (this.action !== "") {
          if(this.$route.query.id) {
            this[this.action](this.$route.query.id);
          } else {
            this[this.action]();
          }
        }
        this.$emit("resetAction");
        if(this.project.status === 3) {
          this.dateSelector = this.$moment.unix(this.project.endDate);
        }
      });
    },
    updateData() {
      if(!this.$store.getters['offline/isOffline'] && !document.hasFocus()) {
        this.$http
        .get("project/events?idProject=" + this.projectId)
        .then(response => {
          if (response.data) {
            Promise.all([
              this.$store.dispatch('events/update', {
                vlf: this.$vlf('events'),
                objs: response.data.events
              }),
              this.$store.dispatch('invites/update', {
                vlf: this.$vlf('invites'),
                objs: response.data.invites
              }),
            ]);
          }
        })
        .catch(error => console.log(error));
      }
    },
    timerStart() {
      const runningTask = {"p":this.projectId, "pn":this.project.name, "st":Math.round(Date.now() / 1000)};
      this.$store.commit('headbar/runningTask', runningTask);
      this.$anm22.setCookie("tk_r_t", JSON.stringify(runningTask), 31536000);
    },
    timerStop() {
      this.deleteRunningTask = true;
      this.addEventByStartTime(this.runningTask.st);
    },
  },
  created() {
    this.loadData();
    this.loading = true;
    this.$http
      .get("project/events?idProject=" + this.projectId)
      .then(response => {
        if (response.data) {
          Promise.all([
            this.$store.dispatch('events/update', {
              vlf: this.$vlf('events'),
              objs: response.data.events
            }),
            this.$store.dispatch('invites/update', {
              vlf: this.$vlf('invites'),
              objs: response.data.invites
            }),
            this.$store.dispatch('employeeExpenseReports/update', {
              vlf: this.$vlf('employeeExpenseReports'),
              objs: response.data.employeeExpenseReports
            }),
          ])
          .then(() => {
            if(this.project.status === 3) {
              this.dateSelector = this.$moment.unix(this.project.endDate);
            }
            this.$store.dispatch('offline/sync', {
              _vue: this, blocking: true, callback: async data => {
                const update = data.success.find(d => d.requestData.obj.idWorldProject === this.$route.params.id);
                if(update) {
                  this.$router.replace('/project/'+update.responseData.idWorldProject);
                }
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
      .catch(error => {
      });
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  },
  destroyed() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", null);
    clearInterval(this.updateInterval);
  },
  components: {
    EventDetail,
    "vue-simple-spinner": Spinner
  }
};
</script>

<style lang="scss" scoped>
.event-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 5px;
  padding: 8px;
  max-width: 600px;
  line-height: 1;
  box-shadow: 0 3px 6px rgba(0,0,0,.1), 0 3px 6px rgba(0,0,0,.1);
  .icon {
    margin-right: 5px;
  }
  .name {
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    color: #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .img {
    margin-left: 5px;
  }
  .user {
    margin-left: 5px;
  }
}
.event-plus-div {
  min-height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
}
.copy-event {
  position: absolute;
  right: 89px;
  top: 13px;
  display: block;
  margin: 0;
}
.timezone-btn {
  background-color: #fff;
  margin-left: 5px;
  padding: 5px;
  font-size: 14px;
  border: 2px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  &.selected {
    border: 2px solid #0aabf4;
    cursor: default;
  }
}

.headbar-notification-running-task {
  position: relative;
  width: 100%;
  height: 52px;
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 5px 0;
  margin: 10px 0 0 0;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;

  .sprint-icon {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 30px;
    opacity: 0.6;
  }
  .running-task-title {
    position: absolute;
    left: 50px;
    top: 10px;
    font-size: 10px;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
  }
  .running-task-desc {
    position: absolute;
    left: 50px;
    top: 25px;
    font-size: 14px;
  }
  .start-time {
    position: absolute;
    left: 50px;
    top: 20px;
    font-size: 22px;
    .time-label {
      font-size: 10px;
      display: inline-block;
      text-align: bottom;
      margin-right: 5px;
    }
  }
  .play-btn,
  .stop-btn {
    position: absolute;
    top: 10px;
    width:30px;
    height:30px;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 5px;
    background-color: #ccc;
    cursor: pointer;

    img {
      opacity: 0.6;
      width: 20px;
      height: 20px;
    }
  }
  .play-btn {
    left: 10px;
  }
  .stop-btn {
    right: 10px;
  }
}
</style>

